import { Minus, Plus } from "react-feather";
import styled, { css } from "styled-components";
import { COLOR_WHITE, COLOR_YELLOW } from "../constants/colors";
import { Subtitle1 } from "./Typography";

type InputNumberProps = {
  value: number;
  onChange: (value: number) => void;
};

const InputNumberContainer = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: stretch;
  border: 2px solid ${COLOR_YELLOW};
  border-radius: 12px;

  @media (max-width: 768px) {
    border-radius: 8px;
  }
`;

const NumberInput = styled.input`
  ${Subtitle1}
  border: none;
  outline: none;
  width: 80px;
  height: 52px;
  background: none;
  color: ${COLOR_WHITE};
  text-align: center;

  @media (max-width: 768px) {
    width: 55px;
    height: 40px;
  }
`;

const IconWrapper = styled.div`
  width: 100%;
  height: 52px;

  @media (max-width: 768px) {
    height: 40px;
  }

  display: flex;
  cursor: pointer;
`;

const Icon = css`
  width: 24px;
  height: 24px;
  color: ${COLOR_WHITE};

  margin: auto;

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }
`;

const IcPlus = styled(Plus)`
  ${Icon}
`;

const IcMinus = styled(Minus)<{ disabled: boolean }>`
  ${Icon}
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `};
`;

function InputNumber(props: InputNumberProps) {
  const { value, onChange } = props;

  const onInputChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "" || e.target.value === "0") {
      onChange(1);
      return;
    }
    onChange(Number(e.target.value));
  };

  const handlePlus = () => {
    onChange(value + 1);
  };

  const handleMinus = () => {
    if (value > 1) {
      onChange(value - 1);
    }
  };

  return (
    <InputNumberContainer>
      <IconWrapper className="ps-3" onClick={handleMinus}>
        <IcMinus disabled={value === 0 || value === 1} />
      </IconWrapper>
      <NumberInput
        value={value}
        onChange={onInputChanged}
        onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }}
      />
      <IconWrapper className="pe-3" onClick={handlePlus}>
        <IcPlus />
      </IconWrapper>
    </InputNumberContainer>
  );
}

export default InputNumber;
